import React, { useCallback, useRef } from "react";

import { CloseIcon, TextIcon } from "../../../components/Icons";
import { RichTextEditor } from "../RichTextEditor";

interface Props {
  menuRef: React.RefObject<HTMLDivElement>;
  isHorizontal: boolean;
  onDone: (markdown: string) => void;
  onClose: () => void;
}

export const AddTextBlockForm: React.FC<Props> = ({ menuRef, isHorizontal, onDone, onClose }) => {
  const getMarkdownRef = useRef<(() => string) | null>(null);

  const handleDone = useCallback(() => {
    const markdown = getMarkdownRef.current?.() ?? "";
    onDone(markdown);
  }, [onDone]);

  return (
    <div
      ref={menuRef}
      className={`absolute z-50 bg-white rounded-2xl shadow-xl border border-gray-200 w-[480px] flex flex-col ${
        isHorizontal ? "top-5" : "left-5"
      }`}
      onClick={e => e.stopPropagation()}
      onMouseDown={e => e.stopPropagation()}
    >
      <div className="px-5 pt-4 pb-3 flex justify-between items-center text-sm font-bold text-gray-900 shrink-0">
        <div className="gap-1 flex items-center justify-start">
          <TextIcon />
          <span>Add Text Block</span>
        </div>
        <button
          className="bg-gray-100 rounded-full p-2 cursor-pointer"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon fill="#595959" />
        </button>
      </div>
      <RichTextEditor
        initialMarkdown=""
        getMarkdownRef={getMarkdownRef}
        placeholder="Enter text..."
        minHeight="240px"
        showToolbar
        // Use has() and :focus pseudo selectors to apply border when the child contenteditable div is focused
        className="flex-1 min-h-0 mx-4 mb-4 border border-gray-200 rounded-xl has-[:focus]:-outline-offset-1 has-[:focus]:outline-2 has-[:focus]:outline-blue-500"
        namespace="AddBlockTextBlock"
      />
      <div className="px-4 py-2.5 flex justify-end gap-2 shrink-0">
        <button
          onClick={handleDone}
          className="px-4 py-1.5 bg-primary-button-background text-primary-button-foreground text-sm font-medium rounded-md hover:bg-primary-button-hover-background hover:text-primary-button-hover-foreground cursor-pointer transition-colors"
          aria-label="Add"
        >
          Add
        </button>
      </div>
    </div>
  );
};
